module.exports = __webpack_public_path__ + "img/01-images-girl-mgs.4d12cef7.png";